
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_1bmln_17",
  "arrow": "awsui_arrow_18eso_1bmln_17",
  "in-filtering-token-root": "awsui_in-filtering-token-root_18eso_1bmln_77",
  "in-filtering-token-nested": "awsui_in-filtering-token-nested_18eso_1bmln_77",
  "has-caret": "awsui_has-caret_18eso_1bmln_113",
  "placeholder": "awsui_placeholder_18eso_1bmln_116",
  "pressed": "awsui_pressed_18eso_1bmln_132",
  "disabled": "awsui_disabled_18eso_1bmln_138",
  "in-filtering-token": "awsui_in-filtering-token_18eso_1bmln_77",
  "readonly": "awsui_readonly_18eso_1bmln_159",
  "compact": "awsui_compact_18eso_1bmln_171",
  "invalid": "awsui_invalid_18eso_1bmln_180",
  "warning": "awsui_warning_18eso_1bmln_189",
  "custom-option": "awsui_custom-option_18eso_1bmln_204",
  "inline-tokens": "awsui_inline-tokens_18eso_1bmln_209",
  "grouped": "awsui_grouped_18eso_1bmln_251",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_18eso_1bmln_257",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_18eso_1bmln_261",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_18eso_1bmln_267",
  "grouped-vertical-first": "awsui_grouped-vertical-first_18eso_1bmln_271",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_18eso_1bmln_275",
  "grouped-vertical-last": "awsui_grouped-vertical-last_18eso_1bmln_281",
  "grouped-with-action": "awsui_grouped-with-action_18eso_1bmln_285"
};
  